import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatToolbarModule } from '@angular/material/toolbar';

import { SnCommonModule } from '@lib/common';
import { SnRouterModule } from '@lib/state/router';
import { SnTitleModule } from '@lib/state/title';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnBrandModule } from '@lib/ui/brand';
import { SnButtonModule } from '@lib/ui/button';
import { DebugPanelModule } from '@lib/ui/debug-panel';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnSearchbarModule } from '@lib/ui/searchbar';
import { SnTooltipModule } from '@lib/ui/tooltip';

import {
  SnLayoutAppbarActionsComponent,
  SnLayoutAppbarNavButtonComponent,
  SnLayoutNavbarPrimaryComponent,
  SnLayoutNavbarSecondaryComponent,
  SnLayoutNavbarCollapseButtonComponent,
} from './components';
import { LayoutSecondaryNavbarCollapseButtonComponent } from './components/layout-secondary-navbar-collapse-button/layout-secondary-navbar-collapse-button.component';
import { SnLayoutNavbarContainer, SnLayoutAppbarContainer } from './containers';
import { SnLayoutContentDirective, SnLayoutNavbarToggleDirective } from './directives';
import { snLayoutAppbarConfigFactory, snLayoutNavbarConfigFactory } from './factories';
import { ISnLayoutConfig } from './interfaces';
import { SnLayoutNavbarConfig, SnLayoutAppbarConfig } from './models';
import { SN_LAYOUT_CONFIG } from './providers';
import { SnLayoutService, SnLayoutStorageService } from './services';

@NgModule({
  imports: [
    // Angular
    FormsModule,
    ReactiveFormsModule,
    // Mat
    MatToolbarModule,
    MatButtonModule,
    MatChipsModule,
    // Libs
    SnIconModule,
    SnBrandModule,
    SnTitleModule,
    SnCommonModule,
    SnButtonModule,
    SnRouterModule,
    SnDrawerModule,
    SnTooltipModule,
    SnActionsModule,
    SnSearchbarModule,
    TranslationModule,
    DebugPanelModule,
  ],
  exports: [
    // Directives
    SnLayoutContentDirective,
    SnLayoutNavbarToggleDirective,
    // Containers
    SnLayoutNavbarContainer,
    SnLayoutAppbarContainer,
  ],
  declarations: [
    // Directives
    SnLayoutContentDirective,
    SnLayoutNavbarToggleDirective,
    // Components
    SnLayoutAppbarActionsComponent,
    SnLayoutAppbarNavButtonComponent,
    SnLayoutNavbarPrimaryComponent,
    SnLayoutNavbarSecondaryComponent,
    SnLayoutNavbarCollapseButtonComponent,
    // Containers
    SnLayoutNavbarContainer,
    SnLayoutAppbarContainer,
    LayoutSecondaryNavbarCollapseButtonComponent,
  ],
})
export class SnLayoutModule {
  public static initLayout(config: ISnLayoutConfig = {}): ModuleWithProviders<SnLayoutModule> {
    return {
      ngModule: SnLayoutModule,
      providers: [
        SnLayoutService,
        SnLayoutStorageService,
        {
          provide: SN_LAYOUT_CONFIG,
          useValue: config,
        },
        {
          provide: SnLayoutNavbarConfig,
          useFactory: snLayoutNavbarConfigFactory,
          deps: [SN_LAYOUT_CONFIG],
        },
        {
          provide: SnLayoutAppbarConfig,
          useFactory: snLayoutAppbarConfigFactory,
          deps: [SN_LAYOUT_CONFIG],
        },
      ],
    };
  }
}
